// extracted by mini-css-extract-plugin
module.exports = {"proposal":"Proposal_proposal__26ydo","options":"Proposal_options__2bIGS","buttons-container":"Proposal_buttons-container__19sky"};